/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { accountActions, commonActions } from '../../actions/';
import Spinners from '../Spinners';
import { connect } from 'react-redux';
import DefaultLayout from '../../layout/DefaultLayout';
import { withMsal } from '@azure/msal-react';
import { withRouter } from '../../helpers';

class PrivateRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isAuthenticated: false,
    };
    this.isVerifiedByTwilio = this.isVerifiedByTwilio.bind(this);
    this.checkMicrosoftUserStatus = this.checkMicrosoftUserStatus.bind(this);
    this.logout = this.logout.bind(this);
  }

  isVerifiedByTwilio() {
    try {
      this.user = JSON.parse(localStorage.getItem('payload'));
      const { sub } = this.user;
      const twilioVerificationToken = sub;
      let twilioToken = 'twilio';
      twilioToken = '_' + twilioToken;
      const verifiedByTwilio = localStorage.getItem(twilioToken);
      return (
        verifiedByTwilio && twilioVerificationToken && verifiedByTwilio === twilioVerificationToken
      );
    } catch {
      return false;
    }
  }

  async checkMicrosoftUserStatus() {
    try {
      const msalInstance = this.props.msalContext.instance;
      if (!msalInstance) {
        console.error('MSAL instance is not available.');
        return;
      }

      let allAccounts = msalInstance.getAllAccounts();
      let selectedAccount = null;

      const storedUsername = localStorage.getItem('preferredAzureAccount');

      if (storedUsername) {
        selectedAccount = allAccounts.find((acc) => acc.username === storedUsername);
      }

      if (!selectedAccount && allAccounts.length === 1) {
        selectedAccount = allAccounts[0];
      } else if (!selectedAccount && allAccounts.length > 1) {
        console.warn('Multiple accounts found. Selecting the first available account.');
        selectedAccount = allAccounts[0];
      }

      localStorage.setItem('preferredAzureAccount', selectedAccount.username);
      msalInstance.setActiveAccount(selectedAccount);

      const accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: ['User.Read'],
        account: selectedAccount,
        forceRefresh: true,
      });

      const accessToken = accessTokenResponse.accessToken;

      const meResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      const meData = await meResponse.json();

      if (!meResponse.ok) {
        throw new Error(meData.error?.message || 'Failed to fetch user data');
      }

      console.debug('User is active:', meData);
      localStorage.setItem('microsoftUserActive', true);
    } catch (error) {
      console.error('Error checking user status:', error);
    }
  }

  logout() {
    this.props.logout(() => {
      this.props.navigate('/login');
      localStorage.clear();
    });
  }

  componentDidMount() {
    const userEnteredOtp = localStorage.getItem('QCBD');
    this.props.getSession((err) => {
      if (!err && (userEnteredOtp == 'ERTM' || window.location.hostname == 'localhost')) {
        this.setState({
          loading: false,
          isAuthenticated: true,
        });
        this.props.toggleSidebar(true);
        let login_option = localStorage.login_option;
        if (login_option === 'new') {
          this.checkMicrosoftUserStatus();
        }
      } else {
        this.setState({
          loading: false,
          isAuthenticated: false,
        });
      }
    });
  }

  render() {
    if (this.state.loading) {
      return <Spinners />;
    }

    if (!this.state.isAuthenticated) {
      return <Navigate to="/login" state={{ from: this.props.location }} replace />;
    }

    return (
      <div>
        {this.props.loader ? <Spinners /> : ''}
        <DefaultLayout {...this.props} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loader } = state;
  return {
    loader,
  };
}

const mapDispatchToProps = (dispatch) => ({
  logout: (callback) => dispatch(accountActions.logout(callback)),
  getSession: (callback) => dispatch(accountActions.getSession(callback)),
  toggleSidebar: (queryDetails, callback) =>
    dispatch(commonActions.toggleSidebar(queryDetails, callback)),
});

export default withMsal(withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)));
